import { getEditor } from './../editors';
import { getRenderer } from './../renderers';
import { getValidator } from './../validators';
var CELL_TYPE = 'autocomplete';
export default {
  editor: getEditor(CELL_TYPE),
  renderer: getRenderer(CELL_TYPE),
  validator: getValidator(CELL_TYPE)
};


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/cellTypes/autocompleteType.js
// module id = SwiP
// module chunks = 0